// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__MRqKC","close_button":"Banner_close_button__Uelxa","hidden":"Banner_hidden__j8f+T"};